<template>
  <div :id="id" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <slot name="header"></slot>
          </h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer py-3 px-4">
          <slot name="footer">
            <button
              type="button"
              class="btn btn-sm btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jQuery from "jquery";
export default {
  name: "Modal",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  mounted() {
    let root = this;
    jQuery(`#${this.id}`).on("hidden.bs.modal", () => {
      root.$store.commit("HIDE_MODAL");
    });
  },
};
</script>
